import React from "react";
import { Avatar, Box, Typography } from "@mui/material";

export default function NetworkPersonTile({ person, onClick }) {
  return (
    <Box
      role="button"
      tabIndex={0}
      onClick={() => onClick?.(person)}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onClick?.(person);
        }
      }}
      sx={{
        minWidth: 96,
        textAlign: "center",
        cursor: "pointer",
        borderRadius: 3,
        px: 0.6,
        py: 0.8,
        transition: "background-color 160ms ease, box-shadow 160ms ease, transform 160ms ease",
        "&:hover": {
          backgroundColor: "rgba(237, 243, 249, 0.72)",
          transform: "translateY(-1px)",
        },
        "&:focus-visible": {
          outline: "none",
          backgroundColor: "rgba(237, 243, 249, 0.82)",
          boxShadow: "0 0 0 2px rgba(23, 52, 93, 0.14)",
        },
      }}
    >
      <Box sx={{ position: "relative", width: 78, mx: "auto" }}>
        <Box
          sx={{
            width: 78,
            height: 78,
            borderRadius: "50%",
            display: "grid",
            placeItems: "center",
            background: `linear-gradient(135deg, ${person?.ringColor || "#5b45ff"} 0%, rgba(255,255,255,1) 72%)`,
            p: "2px",
          }}
        >
          <Avatar
            src={person?.image || ""}
            sx={{ width: 74, height: 74, bgcolor: "#f3f5f9", fontSize: "0.95rem" }}
          >
            {(person?.name || "TB").slice(0, 1).toUpperCase()}
          </Avatar>
        </Box>
        <Box
          sx={{
            position: "absolute",
            right: 4,
            bottom: 6,
            width: 16,
            height: 16,
            borderRadius: "50%",
            bgcolor: person?.ringColor || "#29c284",
            border: "2px solid #fff",
          }}
        />
      </Box>

      <Typography variant="subtitle2" fontWeight={800} sx={{ mt: 1, color: "#1d2746" }}>
        {person?.name || "TrustBud"}
      </Typography>
      <Typography variant="caption" sx={{ color: person?.textColor || "#7b8794", fontWeight: 600 }}>
        {person?.statusLabel || ""}
      </Typography>
    </Box>
  );
}
